/*
 * @Description: description
 * @Author: chenguobiao
 * @Date: 2021-09-13 09:29:47
 * @LastEditTime: 2022-01-29 11:17:38
 * @LastEditors: chenguobiao
 */
/**
 * Mixins
 * @param {*} Vue
 */
import config from './config'

export const registerMixins = Vue => {
  Vue.mixin(config)
}
